import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

type IProps = {
  onClick?: () => void | Promise<void>;
  children?: React.ReactNode;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  loading: boolean;
  disabled?: boolean;
  variant?: 'primary' | 'secondary';
  style?: React.CSSProperties;
};

function Button(props: IProps) {
  const classNames = twMerge(
    clsx('w-full border rounded-full cursor-pointer mt-7 p-4 max-h-[52px]', props.className, {
      'bg-action-default border-none hover:bg-action-hover focus:bg-action-focus active:bg-action-active flex items-center justify-center':
        props.variant === 'primary',
      'bg-surface-primary border-action-default hover:bg-surface-primary': props.variant === 'secondary',
      'btn loading flex items-center justify-center gap-3 cursor-default pointer-events-none': props.loading,
      'opacity-40 bg-action-default hover:bg-action-default cursor-default pointer-events-none`': props.disabled,
    })
  );

  const handleClick = async () => {
    if (props.onClick) {
      await props.onClick();
    }
  };
  return (
    <button className={classNames} onClick={handleClick} disabled={props.disabled}>
      {props.loading && (
        <div className="btn-loader">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
      )}
      {!props.loading && props.children}
    </button>
  );
}

export default Button;
